import { useMemo } from 'react';
import { UnreachableI18nCaseError } from '../utils/i18nUtils';
import { useGetHasScope } from './useGetHasScope';
const getReadWriteScopeName = (approvalData, action) => {
  const approvalType = approvalData.meta.approvalType;
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      return `email-approval-${action}`;
    case 'BLOG_POST':
      return `blog-approval-${action}`;
    case 'LANDING_PAGE':
      return `landingpages-approval-${action}`;
    case 'SITE_PAGE':
      return `pages-approval-${action}`;
    case 'DEAL':
      return `deal-approval-${action}`;
    case 'KNOWLEDGE_ARTICLE':
      return `knowledge-article-approval-${action}`;
    case 'QUOTE':
      return `quote-approval-${action}`;
    case 'SOCIAL_BROADCAST':
      return `social-broadcast-approval-${action}`;
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
};
export const useHasReadWriteScope = (approvalData, action) => {
  const hasScope = useGetHasScope();
  return useMemo(() => hasScope(getReadWriteScopeName(approvalData, action)), [approvalData, action, hasScope]);
};